/** Fired on `window` once a download from an AI chat (image, PDF or video) has saved. */
export const AI_CHAT_ASSET_DOWNLOADED_EVENT = 'ai-chat-asset-downloaded';

export interface AiChatAssetDownloadedEventDetail {
  chatId: string;
}

export const dispatchAiChatAssetDownloaded = (chatId: string): void => {
  window.dispatchEvent(new CustomEvent<AiChatAssetDownloadedEventDetail>(AI_CHAT_ASSET_DOWNLOADED_EVENT, {detail: {chatId}}));
};

/** The chat a {@link AI_CHAT_ASSET_DOWNLOADED_EVENT} came from; null for any other event. */
export const getDownloadedAssetChatId = (event: Event): string | null => {
  if (!(event instanceof CustomEvent)) {
    return null;
  }

  const detail: unknown = event.detail;
  if (typeof detail !== 'object' || detail === null || !('chatId' in detail) || typeof detail.chatId !== 'string') {
    return null;
  }

  return detail.chatId;
};
